import React from "react";

export const BRANCHES_PAGE_TITLE = "Branches";

export const branchTableColumns = [
  {
    key: "branch_name",
    header: "Branch Name",
    render: (row) => <strong>{row.branch_name}</strong>,
  },
  {
    key: "location",
    hideBelow: "xxl",
    header: "Location",
    width: "180px",
    render: (row) => `${row.address?.city ?? ""}, ${row.address?.state ?? ""}`,
  },
  {
    key: "admin",
    header: "Admin",
    hideBelow: "xl",
    width: "220px",
    wrap: true,
    render: (row) => (
      <>
        <div>{row.admin_name}</div>
        <div style={{ fontSize: "12px", color: "#64748b" }}>{row.admin_email}</div>
      </>
    ),
  },
  { key: "employeeCount", header: "Employees", align: "center", hideBelow: "xxl", width: "90px" },
  { key: "customerCount", header: "Customers", align: "center", hideBelow: "lg", width: "90px" },
];
